import React from 'react';
import { Link } from 'react-router';
import styles from './NavMokaLogo.css';

export default class NavMokaLogo extends React.Component {
  render() {
    const { isMokaOpenApiRedirect } = this.props;
    let logo = '';
    if (isMokaOpenApiRedirect) {
      logo = require('assets/images/logo-moka-white.svg');
    } else {
      logo = require('assets/images/logo-moka.png');
    }
    return (
      <div className={`${styles.wrapper}`}>
        <Link to={this.props.link} className="navbar-brand mk-brand">
          <img src={logo} className="logo-moka" />
        </Link>
      </div>
    );
  }
}
